const IsLoadedReducer = (isLoaded=false, action) => {
    if (action.type === "IS_SITE_LOADED") {
      return action.payload;
    }
    return isLoaded;
  };
  
  export default IsLoadedReducer;